export enum SignInProcessSteps {
  PhoneNumberStep = 'PhoneNumberStep',
  VerificationCodeStep = 'VerificationCodeStep',
  RedirectToResumeProcessStep = 'RedirectToResumeProcessStep',
}
